import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";
import rgba from "../../functions/rgba";

const { inputBorderColor, primary, error, text, grey } = colors;
const { size } = typography;

const inputOutlined = {
  styleOverrides: {
    root: {
      backgroundColor: "rgba(255, 255, 255, 0.06)",
      fontSize: pxToRem(14),
      borderRadius: pxToRem(4),
      minHeight: pxToRem(32),

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: rgba(inputBorderColor, 0.95),
      },

      "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: primary.main,
          borderWidth: "2px",
        },
      },

      "&.Mui-error": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: error.main,
        },
      },

      "&.Mui-disabled": {
        backgroundColor: "rgba(255, 255, 255, 0.04)",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: rgba(inputBorderColor, 0.35),
        },
      },
    },

    notchedOutline: {
      top: 0,
      borderColor: "rgba(255, 255, 255, 0.28)",
      borderWidth: "1px",
      transition: "border-color 0.12s ease",
      "& legend": {
        display: "none",
      },
    },

    input: {
      color: text.main,
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
      backgroundColor: "transparent",
      fontSize: pxToRem(14),
      lineHeight: "20px",
      height: "auto",

      "&::placeholder": {
        color: grey[400],
        opacity: 1,
      },

      "&[type='date'], &[type='time'], &[type='datetime-local']": {
        display: "block",
        minHeight: "20px",
        lineHeight: "20px",
        colorScheme: "dark",
        "&::-webkit-datetime-edit": {
          padding: 0,
          display: "inline-flex",
          alignItems: "center",
        },
        "&::-webkit-calendar-picker-indicator": {
          width: pxToRem(16),
          height: pxToRem(16),
          padding: 0,
          margin: 0,
          cursor: "pointer",
          opacity: 0.72,
        },
      },
    },

    inputSizeSmall: {
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
      fontSize: pxToRem(14),
    },

    multiline: {
      color: text.main,
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
      fontSize: size.sm,
    },
  },
};

export default inputOutlined;
